import React from 'react';

/**
 * Local, in-memory version selection for the *published* (read-only) grid:
 * readers can toggle which versions are plotted without mutating the persisted
 * Slate document. Seeds from the published `membershipIds` and re-syncs to them
 * whenever they change upstream — done as a render-time reset rather than an
 * effect (preferred per repo guidance), guarded by a value key so it can't loop.
 */
export function usePublishedArtifactVersionMembershipIds(
  metadataMembershipIds: string[]
) {
  const [localMembershipIds, setLocalMembershipIds] = React.useState(
    metadataMembershipIds
  );
  const metadataMembershipIdsKey = JSON.stringify(metadataMembershipIds);
  const previousMetadataMembershipIdsKey = React.useRef(
    metadataMembershipIdsKey
  );

  // oxlint-disable-next-line react/refs
  if (previousMetadataMembershipIdsKey.current !== metadataMembershipIdsKey) {
    // oxlint-disable-next-line react/refs
    previousMetadataMembershipIdsKey.current = metadataMembershipIdsKey;
    setLocalMembershipIds(metadataMembershipIds);
  }

  return [localMembershipIds, setLocalMembershipIds] as const;
}
